import { render, staticRenderFns } from "./FrontendLayout.vue?vue&type=template&id=01c35286"
import script from "./FrontendLayout.vue?vue&type=script&lang=js"
export * from "./FrontendLayout.vue?vue&type=script&lang=js"
import style0 from "./FrontendLayout.vue?vue&type=style&index=0&id=01c35286&prod&lang=scss"
import style1 from "./FrontendLayout.vue?vue&type=style&index=1&id=01c35286&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports